import { cn } from "@/lib/utils";

/**
 * ContourField — survey-inspired contour line graphic. Decorative only.
 * Rendered as an SVG so it stays crisp and weightless.
 */
export const ContourField = ({ className, stroke = "#C8C2B7", opacity = 0.5 }) => {
  return (
    <svg
      className={cn("pointer-events-none select-none", className)}
      viewBox="0 0 600 400"
      fill="none"
      aria-hidden="true"
      preserveAspectRatio="xMidYMid slice"
    >
      <g stroke={stroke} strokeWidth="1" opacity={opacity} fill="none">
        <path d="M-20 320 C 120 300, 200 260, 320 280 S 560 340, 640 300" />
        <path d="M-20 290 C 120 265, 210 220, 330 245 S 560 310, 640 265" />
        <path d="M-20 260 C 130 230, 220 185, 340 210 S 560 280, 640 230" />
        <path d="M-20 230 C 140 198, 235 150, 350 178 S 560 250, 640 196" strokeDasharray="4 5" />
        <path d="M-20 200 C 150 168, 245 120, 360 148 S 560 220, 640 164" strokeDasharray="4 5" />
        <path d="M-20 168 C 160 138, 255 92, 372 120 S 560 190, 640 132" opacity="0.6" />
        <path d="M-20 136 C 170 108, 268 66, 384 94 S 560 158, 640 100" opacity="0.4" />
      </g>
      <g fill={stroke} opacity={opacity}>
        <circle cx="320" cy="280" r="2.5" />
        <circle cx="350" cy="178" r="2.5" />
        <circle cx="372" cy="120" r="2" />
      </g>
    </svg>
  );
};

export default ContourField;
